module.exports = __webpack_public_path__ + "static/media/activestar.75f46a36.svg";